import { defaultTranslations, KDSTranslation } from '@kaseya-design-components';
import { CustomKDSTranslationKey } from '@core/translation/models/kds-translations/custom-kds-translation-key.enum';
import { Language } from '@kaseya-shared';

export const kdsTranslations: Record<Language, KDSTranslation & Record<CustomKDSTranslationKey, string>> = {
  [Language.EnUs]: {
    ...defaultTranslations,
    [CustomKDSTranslationKey.InvalidCardNumber]: 'Invalid card number',
    [CustomKDSTranslationKey.InvalidExpirationDate]: 'Invalid expiration date',
    [CustomKDSTranslationKey.AccountNumberMismatch]: 'Account numbers do not match.',
    [CustomKDSTranslationKey.UserAlreadyExists]: `This user has already been invited to KaseyaOne. Invite another user or select "I will set up KaseyaOne myself" to proceed.`,
    [CustomKDSTranslationKey.RoleNameTooShort]: 'Role name must be at least {{ minLength }} characters.',
    [CustomKDSTranslationKey.RoleNameTooLong]: 'Role name cannot be longer than {{ maxLength }} characters.',
    [CustomKDSTranslationKey.InvalidRoleNameCharacters]:
      "Role name can only contain letters, numbers, spaces, and basic punctuation (.!?()_'&-).",
    [CustomKDSTranslationKey.RoleNameConflict]: 'A role with this name already exists in your organization.',
    [CustomKDSTranslationKey.RoleDescriptionTooShort]: 'Description must be at least {{ minLength }} characters.',
    [CustomKDSTranslationKey.RoleDescriptionTooLong]: 'Description cannot be longer than {{ maxLength }} characters.',
    [CustomKDSTranslationKey.InvalidRoleDescriptionCharacters]:
      "Role description can only contain letters, numbers, whitespace, and basic punctuation (.,!?()_'&-).",
  },
};
